<template>
  <div>
    <q-select
      ref="search_input"
      class="search-bar"
      dense filled
      :label="t('search') | capitalize"
      bg-color="white"
      use-input
      map-options
      hide-selected
      autofocus
      hide-dropdown-icon
      :value="input"
      :options="options"
      :loading="loading"
      :input-debounce="100"
      @filter="setOptions"
      @input="viewResultMain"
      @keyup.enter="onSearch"
    >
      <template v-slot:append v-if="!loading">
        <q-icon name="search" @click="onSearch" class="cursor-pointer q-pr-sm" style="color: grey"/>
        <q-icon
          v-if="!$q.platform.is.mobile"
          name="arrow_drop_down"
          @click="toggleAdvancedSearch"
          class="cursor-pointer q-pr-sm arrow_drop_down"
          :style="{ transform: showAdvancedSearch ? 'rotate(180deg)' : 'rotate(0deg)' }"
        />
      </template>
      <template v-slot:loading v-if="loading" >
        <q-spinner color="primary" class="q-pr-sm" />
      </template>
      <template v-slot:option="scope">
        <q-item
          v-bind="scope.itemProps"
          v-on="scope.itemEvents"
        >
          <q-item-section>
            <q-item-label>{{ scope.opt.label }}</q-item-label>
            <q-item-label caption class="row">
              <q-icon :name="scope.opt.content && scope.opt.content.origin.name === 'geoportal' ? 'las la-compass' : 'location_on'" />
              <div>&nbsp;{{ scope.opt.content && scope.opt.content.origin.name === 'geoportal' ? $t('tools.catalogTree.searchTitle') : scope.opt.caption }}</div>
            </q-item-label>
          </q-item-section>
        </q-item>
      </template>
    </q-select>
      <q-menu
        v-if="!$q.platform.is.mobile && showAdvancedSearch"
        anchor="bottom right"
        self="top right"
        min-width="600px"
        :offset="[170, 2]"
        @hide="showAdvancedSearch = false"
      >
      <div class="no-wrap q-pa-md text-center">
        <div class="row text-center">
          <advanced-search
            @search="advancedSearch"
          />
        </div>
      </div>
    </q-menu>
  </div>
</template>

<script>
import AdvancedSearch from 'src/components/AdvancedSearch'
import { QIcon, QSelect, QSpinner, QItem, QItemLabel, QItemSection, QMenu } from 'quasar'

export default {
  props: {
    query: {
      type: String,
      default: ''
    }
  },
  components: {
    AdvancedSearch,
    QIcon,
    QSelect,
    QSpinner,
    QItem,
    QItemLabel,
    QItemSection,
    QMenu
  },
  data () {
    return {
      input: this.query,
      options: [],
      showAdvancedSearch: false
    }
  },
  computed: {
    loading () {
      return this.$store.state.search.fetchingOptions
    },
    results () {
      return this.$store.getters['search/optionResult']
    }
  },
  watch: {
    query (value) {
      this.input = value
    },
    results (results) {
      if (results) {
        this.options = results.map(result => {
          return {
            content: result,
            value: result.title,
            label: result.title,
            caption: result.subtitle
          }
        })
      } else {
        this.options = []
      }
    }
  },
  methods: {
    t (key, ...args) {
      return this.$t('tools.search.' + key, ...args)
    },
    viewResultMain (value) {
      if (this.$route.params.q !== this.input) {
        this.$router.push({ name: 'search', params: { q: this.input } })
      }
      if (value) {
        this.input = value
        this.$store.dispatch('search/select', { result: this.input.content })
      }
    },
    onSearch () {
      if (!this.input) {
        return
      }
      this.$store.commit('search/setAdvancedSearchOption', null)
      if (this.input instanceof String || typeof this.input === 'string') {
        this.$store.dispatch('search/search', { query: this.input, forceRefresh: true })
        if (this.$route.params.q !== this.input) {
          this.$router.push({ name: 'search', params: { q: this.input } })
        }
      } else {
        this.viewResultMain(this.input)
      }
    },
    toggleAdvancedSearch () {
      this.options = []
      this.showAdvancedSearch = !this.showAdvancedSearch
    },
    advancedSearch (args) {
      this.$store.commit('search/setAdvancedSearchOption', args.option)
      if (args.input instanceof String || typeof args.input === 'string') {
        this.$store.dispatch('search/search', { query: args.input, forceRefresh: true })
        if (this.$route.params.q !== args.input) {
          this.$router.push({ name: 'search', params: { q: args.input } })
        }
      } else {
        this.viewResultMain(args.input)
      }
    },
    setOptions (input, update, abort) {
      update(() => {
        if (!input) {
          return
        }
        const needle = input.toLocaleLowerCase()
        if (needle !== '') {
          this.$store.dispatch('search/optionSearch', { query: needle, forceRefresh: true })
        }
      })
    }
  }
}
</script>

<style scoped>
.q-field__input {
  margin-left: 6px!important;
}
.arrow_drop_down {
  transform-origin: 12px 12px;
  color: grey;
  transition: transform 0.28s ease
}
</style>
